<template>
  <div id="mtn_apps">
    <div class="apps-back">
      <SliderSection id="normal-cards" :obj="mtnAppsRepo" method="getPage" sliderHolder="mtnApps" :data="info" />
    </div>
  </div>
</template>

<script>
import SliderSection from '../../components/sections/SliderSection'
import MtnAppsRepository from '../../repositories/MtnAppsRepository'
import $ from 'jquery'
export default {
  name: 'MtnApps',
  components: { SliderSection },
  data () {
    return {
      mtnAppsRepo: new MtnAppsRepository(),
      info: {
        main: { sectionId: 'mtn_apps', cardType: 'app', title: this.$t('mtnApps.title'), description: this.$t('mtnApps.desc'), image: '' },
        slider: []
      },
      page: 0,
      size: 5,
      totalElements: 0,
      show: false,
      error: false,
      visited: [0],
      shouldBeDragged: 0
    }
  },
  created () {
  },
  mounted () {
    this.arabic()
  },
  methods: {
    arabic () {
      if (this.$lang === 'ar') {
        // this.info.main.image = 'appsArabic.png'
        $('#mtn_apps .apps-back').addClass('ar')
      } else {
        $('#mtn_apps .apps-back').addClass('en')
      }
    }
  }
}
</script>

<style scoped>
/*#mtn_apps {*/
/*  background: url("../../assets/images/back2.png") no-repeat;*/
/*}*/
#mtn_apps {
  margin-top: -210px;
  padding-top: 210px;
}
#mtn_apps .apps-back.ar {
  background: url("../../assets/images/circles-back-ar.png") no-repeat right;
}
#mtn_apps .apps-back.en {
  background: url("../../assets/images/circles-back-en.png") no-repeat;
}
</style>
<style>
.section-container{
  min-height: 600px;
}
</style>
